import * as i18n from './i18n';
import { routes } from './routes';

export default {
    i18n,
    routes
};
